import { Suspense } from 'react';

import { Skeleton } from '@lyearn/ui';
import dynamic from '@/utils/dynamic';

import { SettingsProps } from './types';

const LazySettingsComponent = dynamic(
  () =>
    import(/* webpackPreload: true */ /* webpackChunkName: "content-settings-component" */ './'),
);

const Loader = <Skeleton animation="wave" height={40} variant="circular" width={40} />;

const LazySettings = (props: SettingsProps) => {
  return (
    <Suspense fallback={Loader}>
      <LazySettingsComponent {...props} />
    </Suspense>
  );
};

export default LazySettings;
